import { useState, useEffect, useCallback } from 'react'
import { getLrrMetadataForStandaloneViewer } from '../fetch/get-lrr-metadata-for-standalone-viewer'
import { LrrReferenceMetadataResponse } from '../schema/lrr-reference-viewer.schema'

interface UseLrrMetadataState {
  data: LrrReferenceMetadataResponse | null
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

/**
 * Fetch LRR metadata for the standalone viewer.
 *
 * @param s3Path - The s3 directory path
 */
export function useLrrMetadataInStandalone(s3Path: string): UseLrrMetadataState {
  const [data, setData] = useState<LrrReferenceMetadataResponse | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const fetchData = useCallback(async () => {
    if (!s3Path) {
      setIsError(true)
      setData(null)
      return
    }

    setIsLoading(true)
    setIsError(false)

    try {
      const result = await getLrrMetadataForStandaloneViewer(s3Path)
      setData(result)
    } catch {
      setIsError(true)
      setData(null)
    } finally {
      setIsLoading(false)
    }
  }, [s3Path])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    data,
    isLoading,
    isError,
    refetch: fetchData,
  }
}
